module.exports = __webpack_public_path__ + "img/banner_battleroyal_web.17ad04ab.png";